import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isPrereleaseFeatureEnabled, PrereleaseFeature } from 'hooks/use-feature';
import { useActiveTemplateId } from './use-active-project-template';
const getAllTasksSelector = ()=>createSelector((state)=>state.templates.project, (_, templateId)=>templateId, (project, templateId)=>{
        // Agent: soft-empty when data[templateId] is missing for a remount frame.
        // FF off: pre-agent throw on missing key.
        if (isPrereleaseFeatureEnabled(PrereleaseFeature.TemplateAgentChat, true)) {
            var _ref;
            var _project_data_templateId;
            return (_ref = (_project_data_templateId = project.data[templateId]) === null || _project_data_templateId === void 0 ? void 0 : _project_data_templateId.tasks) !== null && _ref !== void 0 ? _ref : {};
        }
        return project.data[templateId].tasks;
    });
export const useGetAllTasks = ()=>{
    const templateId = useActiveTemplateId();
    const templateObject = useMemo(getAllTasksSelector, []);
    return useSelector((state)=>templateObject(state, templateId));
};
